import authRedux from "./auth/reducer";
import signUpRedux from "./formSignUp/reducer";
import forgotPasswordRedux from "./formForgotPassword/reducer";

export default {
  auth: authRedux,
  signUp: signUpRedux,
  forgotPassword: forgotPasswordRedux,
};
